import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function findAll(payload) {
  const { groupId, farmId } = payload;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/multipleBulls`,
    getHeaders(false, null)
  );
}

export function save(payload) {
  const { groupId, farmId, id, body } = payload;
  if (id === null) {
    return apiAnimals.post(
      `/bovexo/${groupId}/farms/${farmId}/multipleBulls`,
      body,
      getHeaders(false, null)
    );
  } else {
    return apiAnimals.put(
      `/bovexo/${groupId}/farms/${farmId}/multipleBulls/${id}`,
      body,
      getHeaders(false, null)
    );
  }
}

export function destroy(payload) {
  const { groupId, farmId, id } = payload;

  return apiAnimals.delete(
    `/bovexo/${groupId}/farms/${farmId}/multipleBulls/${id}`,
    getHeaders(false, null)
  );
}
